document.addEventListener('DOMContentLoaded', function () {
  const wrapper = document.querySelector('.product-hotspots-wrapper');
  if (!wrapper) return;

  const hotspots = JSON.parse(wrapper.dataset.hotspots || '[]');
  const pathMatch = window.location.pathname.match(/\/products\/([^/?#]+)/);
  const currentHandle = pathMatch ? pathMatch[1] : '';
  const mediaItems = document.querySelectorAll('.product__media-item[data-media-id]');

  const BAG_ICON = `
    <svg viewBox="0 0 24 24">
      <path d="M6 2 3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4Z"/>
      <path d="M3 6h18"/>
      <path d="M16 10a4 4 0 0 1-8 0"/>
    </svg>
  `;
  const CLOSE_ICON = `
    <svg viewBox="0 0 24 24">
      <path d="M5 5l14 14M19 5 5 19"/>
    </svg>
  `;

  const AFFINITY_KEY = 'casa_tag_affinity';

  function bumpTagAffinity(tags, weight) {
    if (!tags || !tags.length) return;
    try {
      const affinity = JSON.parse(localStorage.getItem(AFFINITY_KEY) || '{}');
      tags.forEach(tag => {
        if (!tag) return;
        affinity[tag] = (affinity[tag] || 0) + weight;
      });
      localStorage.setItem(AFFINITY_KEY, JSON.stringify(affinity));
    } catch (e) {}
  }

  function track(eventName, detail) {
    try {
      if (typeof window.clarity === 'function') {
        if (detail) {
          Object.keys(detail).forEach(key => window.clarity('set', key, String(detail[key])));
        }
        window.clarity('event', eventName);
      }
    } catch (e) {}
  }

  const backdrop = document.createElement('div');
  backdrop.className = 'hotspot-modal-backdrop';
  backdrop.innerHTML = `
    <div class="hotspot-modal" role="dialog" aria-modal="true">
      <button type="button" class="hotspot-modal__close" aria-label="Sluiten">${CLOSE_ICON}</button>
      <span class="hotspot-modal__eyebrow">Ook verkrijgbaar met deze foto</span>
      <div class="hotspot-modal__grid"></div>
    </div>
  `;
  document.body.appendChild(backdrop);
  const grid = backdrop.querySelector('.hotspot-modal__grid');

  function closeModal() {
    backdrop.classList.remove('is-open');
    document.documentElement.classList.remove('hotspot-modal-locked');
  }

  function openModal(imageHotspots) {
    grid.innerHTML = '';
    imageHotspots.forEach(hotspot => {
      const card = document.createElement('a');
      card.className = 'hotspot-card';
      card.href = `/products/${hotspot.productHandle}`;
      card.innerHTML = `
        <div class="hotspot-card__image-wrap">
          <img class="hotspot-card__image" alt="${(hotspot.productTitle || '').replace(/"/g, '&quot;')}">
        </div>
        <div class="hotspot-card__body">
          <span class="hotspot-card__title">${hotspot.productTitle || ''}</span>
          <span class="hotspot-card__price"></span>
          <span class="hotspot-card__cta">Bekijk product</span>
        </div>
      `;
      card.addEventListener('click', function () {
        track('hotspot_item_click', {
          hotspot_source_product: currentHandle,
          hotspot_target_product: hotspot.productHandle,
        });
        bumpTagAffinity(card.dataset.tags ? card.dataset.tags.split(',') : [], 3);
      });
      grid.appendChild(card);

      fetch(`/products/${hotspot.productHandle}.js`)
        .then(r => r.json())
        .then(data => {
          const img = card.querySelector('.hotspot-card__image');
          const priceEl = card.querySelector('.hotspot-card__price');
          if (data.featured_image) {
            img.src = data.featured_image.replace(/(\.[^.]+)$/, '_300x300$1');
          }
          if (typeof data.price === 'number') {
            priceEl.textContent = '€' + (data.price / 100).toFixed(2).replace('.', ',');
          }
          if (Array.isArray(data.tags)) {
            card.dataset.tags = data.tags.join(',');
          }
        });
    });

    backdrop.classList.add('is-open');
    document.documentElement.classList.add('hotspot-modal-locked');
  }

  backdrop.addEventListener('click', function (e) {
    if (e.target === backdrop) closeModal();
  });
  backdrop.querySelector('.hotspot-modal__close').addEventListener('click', closeModal);
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeModal();
  });

  mediaItems.forEach(mediaItem => {
    const mediaIdRaw = mediaItem.dataset.mediaId;
    const mediaIdNumber = mediaIdRaw?.split('-').pop();
    const imageGid = `gid://shopify/MediaImage/${mediaIdNumber}`;

    const imageEntry = hotspots.find(h => h.imageId === imageGid);
    const imageHotspots = (imageEntry?.products || []).filter(p => p.productHandle !== currentHandle);
    if (!imageHotspots.length) return;

    const tagWrap = document.createElement('div');
    tagWrap.className = 'hotspot-tag';

    const btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'hotspot-tag__btn';
    btn.setAttribute('aria-label', 'Ook verkrijgbaar met deze foto');
    btn.innerHTML = BAG_ICON;

    if (imageHotspots.length > 1) {
      const count = document.createElement('span');
      count.className = 'hotspot-tag__count';
      count.textContent = imageHotspots.length;
      btn.appendChild(count);
    }

    btn.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      track('hotspot_tag_open', { hotspot_source_product: currentHandle });
      openModal(imageHotspots);
    });

    tagWrap.appendChild(btn);
    mediaItem.appendChild(tagWrap);
  });
});
